import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import checkOrientation from '../util/checkOrientation';

/**
 * This modal will display on mobile devices when rotated to landscape mode or if the screen has a
 * landscape aspect ratio and is less than 600px tall. After being dismissed it will not appear
 */
function OrientationWarningModal() {
  const [orientationWarningShown, setOrientationWarningShown] = useState(false);
  const [orientationWarning, setOrientationWarning] = useState(
    !checkOrientation(),
  );
  const dismissWarning = () => {
    setOrientationWarningShown(true);
  };

  // Add event listener to respond to device rotation
  useEffect(() => {
    const handleOrientationChange = () => {
      // Delay validation after change since the view height & width do not update immediately
      setTimeout(() => {
        setOrientationWarning(!checkOrientation());
      }, 250);
    };
    window.addEventListener('orientationchange', handleOrientationChange);
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return orientationWarning && !orientationWarningShown ? (
    <div className="absolute w-[100vw] h-[100vh] top-0 left-0 z-[1000] bg-black/50">
      <div
        className={clsx(
          'top-[50%] translate-y-[-50%] w-fit max-w-[80%] py-8 px-10',
          'relative rounded bg-white m-auto flex flex-col gap-6 justify-center',
          'text-center text-black',
        )}
      >
        <p className="font-r-14">
          {window.TMW.Strings.customizer.orientationWarning}
        </p>
        <button
          onClick={dismissWarning}
          className={clsx(
            'px-8 py-2 m-auto',
            'uppercase font-gotham border border-black',
            'active:bg-grey-700 active:text-white',
          )}
        >
          Dismiss
        </button>
      </div>
    </div>
  ) : undefined;
}

export default OrientationWarningModal;
